import React from 'react';
import PropTypes from 'prop-types';
import { Divider, Image, Segment } from 'semantic-ui-react';

const ProfileBios = ({ influencer }) => {
  const instagramBio = influencer.instagramBio;
  const twitterBio = influencer.twitterBio;

  return (
    <Segment padded>
      <h3>Social Bios</h3>
      <div className="spacer" />
      <div className="flex">
        <div className="item">
          <Image src="/icons/instagram.svg" alt="instagram" />
        </div>
        <div className="space">
          <p>{instagramBio}</p>
        </div>
      </div>
      <Divider />
      <div className="flex">
        <div className="item">
          <Image src="/icons/twitter.svg" alt="twitter" floated="left" />
        </div>
        <div className="space">
          <p>{twitterBio}</p>
        </div>
      </div>
    </Segment>
  );
};

ProfileBios.propTypes = {
  influencer: PropTypes.object.isRequired,
};

export default ProfileBios;



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/profile-bios.js
 **/